<script>
import CInputCheckbox from './CInputCheckbox.vue'

export default {
  name: 'CInputRadio',
  extends: CInputCheckbox,
  inputType: 'radio'
}
</script>
